import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { LoaderService } from '../services/loader.service';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: 'button[loaderId]',
  standalone: false
})

export class LoadingDirective implements OnInit, OnDestroy {

  @Input() public loaderId: string;

  public originalClasses: string[];
  public loaderClasses: string[] = ['fa-spinner', 'fa-pulse'];

  private subscription = new Subscription();

  constructor(
    private element: ElementRef,
    private loaderService: LoaderService
  ) { }

  public ngOnInit() {
    if (this.loaderId) {
      const el: HTMLInputElement = this.element.nativeElement;
      this.subscription = this.loaderService.createLoader(this.loaderId).pipe(filter(x => !!x)).subscribe(data => {
        el.disabled = data.show === undefined || data.show === null ? el.disabled : data.show;
        const classesToRemove = data.show ? this.originalClasses : this.loaderClasses;
        const classesToAdd = data.show ? this.loaderClasses : this.originalClasses;
        if (classesToAdd && classesToRemove) { this.replaceClass(classesToRemove, classesToAdd, el); }
      });
      if (el && el.firstElementChild && el.firstElementChild.tagName && el.firstElementChild.tagName.toLowerCase() === 'i') {
        setTimeout(() => { this.originalClasses = el.firstElementChild.classList.value.split(' ').filter(x => x.indexOf('fa-') === 0); });
      }
    }
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private replaceClass(classesToRemove: string[], classesToAdd: string[], el: HTMLInputElement) {
    if (el.firstElementChild) {
      classesToRemove.forEach(c => el.firstElementChild.classList.remove(c));
      classesToAdd.forEach(c => el.firstElementChild.classList.add(c));
    }
  }
}
